import { Controller } from "@hotwired/stimulus"

// Usage: data-controller="submit" on a form
//        data-action="change->submit#submit" on elements that should trigger auto-submit
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
